import type { SVGProps } from 'react'
const LineRestaurant = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.5 10.75V2H4v8.75a2.75 2.75 0 0 0 2.75 2.75H7V22h1.5v-8.5h.25a2.75 2.75 0 0 0 2.75-2.75V2H10v8.75c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M13 6.75A4.75 4.75 0 0 1 17.75 2H19v19.75h-1.5V16.5h-1.75A2.75 2.75 0 0 1 13 13.75zM17.5 15V3.51a3.25 3.25 0 0 0-3 3.24v7c0 .69.56 1.25 1.25 1.25z"
			clipRule="evenodd"
		/>
		<path fill="currentColor" d="M7 2v8.5h1.5V2z" />
	</svg>
)
export { LineRestaurant }
